import React, { useEffect, useState } from 'react';
import { Button } from 'tradera/components/atoms/button/button';
import SideMenu from 'tradera/components/side-menu/side-menu';
import { ScrollableModalContent } from 'tradera/components/scrollable-modal/scrollable-modal-content';
import { RadioSwitch } from 'tradera/components/form-controls/radio-switch';
import { WishListItems } from './wish-list-items';
import { useTranslator } from 'tradera/lang/translate';
import { useSelector, useDispatch } from 'react-redux';
import { closeWishListSideSheet } from 'tradera/state/ui/reducer';
import { HeaderWithCloseButton } from 'tradera/components/scrollable-modal/header-with-close-button';
import { SearchInput } from 'tradera/components/form-controls/search-input/search-input';

export const WishListSideSheet = () => {
    const { t } = useTranslator();

    const dispatch = useDispatch();
    const { isOpen } = useSelector((state) => state.ui.wishListSideSheet);

    const [showMayBeMoreResultsText, setShowMayBeMoreResultsText] =
        useState(false);

    const [searchTerm, setSearchTerm] = useState('');

    const filterOptions = [
        { value: 'all', name: t('wishlist_sidesheet_filter_all') },
        {
            value: 'active',
            name: t('wishlist_side_sheet_filter_ongoing')
        },
        {
            value: 'ended',
            name: t('wishlist_sidesheet_filter_ended')
        }
    ];

    const [selectedFilter, setSelectedFilter] = useState('all');

    const handleFilterChange = (filter) => setSelectedFilter(filter);

    const handleSearch = ({ target }) => setSearchTerm(target.value);

    const handleSearchClear = () => setSearchTerm('');

    const handleDismiss = () => dispatch(closeWishListSideSheet());

    useEffect(() => {
        if (isOpen) return;

        handleSearchClear();
        setSelectedFilter('all');
    }, [isOpen]);

    return (
        <SideMenu
            show={isOpen}
            onDismiss={handleDismiss}
            fromLeft={false}
            width="30rem">
            <ScrollableModalContent
                onClose={handleDismiss}
                header={
                    <>
                        <HeaderWithCloseButton
                            onClose={handleDismiss}
                            title={t('wishlist_sidesheet_header')}
                            border
                        />
                        <div className="px-2 px-sm-3">
                            <RadioSwitch
                                id="wish-list-filter"
                                options={filterOptions}
                                defaultChecked={selectedFilter}
                                handleOnChange={handleFilterChange}
                                className="my-2"
                            />
                            <SearchInput
                                placeholder={t(
                                    'wishlist_sidesheet_search_placeholder'
                                )}
                                allowClear
                                value={searchTerm}
                                maxLength="98"
                                onChange={handleSearch}
                            />
                        </div>
                    </>
                }
                className="bg-white"
                innerClassName="flex-grow-1"
                footer={
                    <>
                        {showMayBeMoreResultsText && (
                            <i className="text-muted d-block mb-1 text-wrap">
                                {t('wishlist_sidesheet_may_be_more_resulsts')}
                            </i>
                        )}
                        <Button href="/my/wish-list" fluid>
                            {t('wishlist_sidesheet_to_overview')}
                        </Button>
                    </>
                }>
                <WishListItems
                    filter={selectedFilter}
                    searchTerm={searchTerm}
                    setShowMayBeMoreResultsText={setShowMayBeMoreResultsText}
                />
            </ScrollableModalContent>
        </SideMenu>
    );
};
